export const SEARCH_TIRES_PURPOSE_TRAILER = 'trailer'

export const EV_TIRES_BUTTON_LABEL = 'Shop EV Tires'
export const EV_TIRES_PATH_NAME = 'electric-vehicle-tires'
